export { getSharingURL } from './src/sharing'
export { useSharing } from './src/useSharing'
export type { Platform } from './src/types'
